export default __webpack_public_path__ + "static/media/carousel6.e35cc219.jpg";